import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/folder.svg'


_pushScopeId("data-v-0e8c0cea")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Upload an Image", -1)
const _hoisted_3 = { id: "info" }
const _hoisted_4 = { id: "error" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Sorry, ")
const _hoisted_6 = { style: {"text-decoration":"underline"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" is not an accepted file format. ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Please choose a PNG or JPG file.", -1)
const _hoisted_9 = ["onDrop"]
const _hoisted_10 = ["onDragenter", "onDragleave"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Folder"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Drag and drop a file here", -1)
_popScopeId()

import { ref, inject } from "vue";
import { Ref } from "@vue/reactivity"
import CloseSVG from "@/components/CloseSVG.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    fileName: { type: String, required: true }
  },
  emits: ["uploadClick", "setFileName", "handleClickAndDrop", "closeModalAndCleanInput"],
  setup(__props: any, { emit }: { emit: ({
  (e: "uploadClick"): void;
  (e: "setFileName", name: string): void;
  (e: "handleClickAndDrop", event?: { target?: HTMLInputElement }, fileList?: FileList): void;
  (e: "closeModalAndCleanInput"): void;
}), expose: any, slots: any, attrs: any }) {

// Vue 3.2 script setup api




const dropBox = ref<HTMLDivElement>();
const dropMask = ref<HTMLDivElement>();
const bounceTransition = inject("bounceTransition") as Ref<string>;
const fadeTransition = inject("fadeTransition") as Ref<string>;

const dragEnter = (event: Event): void => {
  event.stopPropagation();
  if (dropBox.value) dropBox.value.classList.add("hover");
};

const dragLeave = (event: Event): void => {
  event.stopPropagation();
  if (dropBox.value) dropBox.value.classList.remove("hover");
};

const handleDragOver = (event: Event): void => {
  event.preventDefault();
};

const dropToAddFile = (e: { dataTransfer: DataTransfer }): void => {
  const fileTypes = ["png", "jpg", "jpeg"];

  const droppedFile = e.dataTransfer.files;
  const splitFile = droppedFile[0].name.split(".");

  if (!droppedFile || !fileTypes.includes(splitFile[1])) {
    emit("setFileName", droppedFile[0].name);
    return;
  }

  emit("handleClickAndDrop", undefined, droppedFile);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(fadeTransition), "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_unref(bounceTransition), "modal-body"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            style: {"height":"30px","width":"30px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModalAndCleanInput')))
          }, [
            _createVNode(CloseSVG, { propId: 'file-type-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.fileName), 1),
            _hoisted_7
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", {
          id: "drag-n-drop",
          ref: (_value, _refs) => {
            _refs['dropBox'] = _value
            dropBox.value = _value
          },
          onDrop: _withModifiers(dropToAddFile, ["prevent"]),
          onDragover: handleDragOver
        }, [
          _createElementVNode("div", {
            id: "drop-mask",
            ref: (_value, _refs) => {
              _refs['dropMask'] = _value
              dropMask.value = _value
            },
            onDragenter: _withModifiers(dragEnter, ["prevent"]),
            onDragleave: _withModifiers(dragLeave, ["prevent"])
          }, null, 40, _hoisted_10),
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("button", {
            "aria-label": "Browse files",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('uploadClick')))
          }, "Browse files...")
        ], 40, _hoisted_9)
      ], 2)
    ], 2)
  ]))
}
}

})